import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CampusProofCard} from './CampusProofCard';
import {CampusButton} from '../Components/CampusButton';
import {ProductSelector} from '../ProductSelector/ProductSelector';
import {browserHistory} from 'react-router';

/* root for image */
declare var ImageRoot: string;

class ProductProps extends Tgcc.BaseProps {
    product: Tgcc.Product;
}

const imgStyle: React.CSSProperties = {
    maxHeight: '180px',
    maxWidth: '180px',
    height: 'auto',
    width: 'auto',
    alignSelf: 'center',
    display: 'flex'
}

const labelStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    fontSize: '11px',
    letterSpacing: '1px',
    textTransformm: 'uppercase'
}

const cStyle: React.CSSProperties ={
    display: 'flex',
    flexDirection: "column",
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
    marginTop:'10px'
}
const productText: React.CSSProperties = {
    fontFamily:'BarlowLight',
    color:'#626161',
    width:'75%',
    textAlign:'center',
    margin:'auto auto'
}

const productText1: React.CSSProperties = {
    fontFamily:'BarlowLight',
    color:'#626161',
    width:'75%',
    textAlign:'center',
    margin:'auto'
}

const btnCont: React.CSSProperties = {
    marginTop:'10px'
}
const step: React.CSSProperties = {
    textAlign:'center',
    textTransform:'uppercase',
    fontFamily:'Lulo',
    fontSize:'20px'
}
const optional: React.CSSProperties = {
    color:'#D46F5A',
    fontFamily:'BarlowLight',
}
class _CampusProductEdit extends React.Component<ProductProps, Tgcc.GlobalState> {

    openProduct = () => {browserHistory.push(Tgcc.Routes.CampusProductListView)}

    handleMissingProductImage = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
    }

    getProductImage(){
        if(this.props.product){
            var p = this.props.product;
            var image = Tgcc.getProductPath(this.props.product.thumbnail.replace(' ', '%20'))
            return ( 
                <div style={cStyle}>
                    <img src={image} style={imgStyle} onError={this.handleMissingProductImage}/>
                    <div style={labelStyle}>{p.brand}&nbsp;{p.style}</div>
                    <div style={labelStyle}>{p.colorName}</div>
                </div>
            );
        }
    }
    ifProduct(){
        if(!this.props.product){
            return (
                <div style={productText}>If you don't know what you want yet - leave this blank and our team will reach out.</div>
            )
        }
    }

    render() {
        var btnText: string = this.props.product ? "Change apparel" : "Choose apparel";
        return (
            <div>
                <div style={step}>Step 3</div>
                <CampusProofCard title="APPAREL" margin='0px 10px' containerHeight='470px' containerWidth='375px'  innerHeight='402px' innerWidth='335px'>
                    <div style={optional}><i>*this step is optional!</i></div>
                    { this.getProductImage() }
                    {this.ifProduct()}
                    <div style={btnCont}>
                    <CampusButton text={btnText}  onClick={this.openProduct} fontFamily='Lulo' display='flex' alignItems='center' margin='auto' fontSize='15px' backgroundColor='#3A54B4' color='white'/>
                    </div>
                    <div style={productText1}>Don&#39;t see what you need? Upload a screenshot in Step 1!</div>
                </CampusProofCard>
            </div>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { product: state.ActiveProof.product }
};

export var CampusProductEdit = connect(mapStateToProps)(Radium(_CampusProductEdit));